import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ApiErrorResponse, AppError, Browser, SsrService } from '@interticket/core';
import { Callout } from '../../models/callout/callout.model';
import { CalloutType } from '../../enums/callout-type.enum';

@Injectable()
export class ErrorService {

  constructor(
    private ssrService: SsrService
  ) { }

  private getClientErrorMessage(error: Error): string {
    return error.message ? error.message : error.toString();
  }

  @Browser()
  private getHttpErrorMessage(error: HttpErrorResponse): string {
    return this.ssrService.navigator.onLine ? error.message : 'no_internet_connection';
  }

  @Browser()
  private getApiErrorMessage(error: ApiErrorResponse): string | string[] {
    return this.ssrService.navigator.onLine ? error?.error?.getErrorLabels() : 'no_internet_connection';
  }

  getErrorMessage(error: AppError): string | string[] {
    let errorMessage: string | string[];
    if (error instanceof ApiErrorResponse) {
      errorMessage = this.getApiErrorMessage(error);
    } else if (error instanceof HttpErrorResponse) {
      errorMessage = this.getHttpErrorMessage(error);
    } else {
      errorMessage = this.getClientErrorMessage(error);
    }

    return errorMessage || 'label_unsuccess_action_try_later';
  }

  getErrorCallout(error: AppError): Callout {
    return new Callout({
      title: 'audit_error_popup_title',
      description: this.getErrorMessage(error),
      type: CalloutType.ERROR,
      correlationId: error instanceof ApiErrorResponse && error.error ? error.error.correlationId : null,
    });
  }

}
